export default __webpack_public_path__ + "static/luker-037bde778645468e92b161e527c93237.jpg";